export const API_URL = process.env.NEXT_PUBLIC_API_URL as string

const ENV = process.env.NEXT_PUBLIC_ENV ?? 'local'

const COOKIE_KEY_PREFIX = ENV === 'prod' ? `alshain_` : `alshain_${ENV}_`
export const ACCESS_TOKEN_KEY = `${COOKIE_KEY_PREFIX}access_token` as string
export const REFRESH_TOKEN_KEY = `${COOKIE_KEY_PREFIX}refresh_token` as string
export const PROXY_STORE_CODE_KEY =
  `${COOKIE_KEY_PREFIX}proxy_store_code` as string
export const PROXY_STORE_NAME_KEY =
  `${COOKIE_KEY_PREFIX}proxy_store_name` as string

export const EMPTY_ITEM_IMAGE_SRC = '/images/empty_item.png'
